module.exports = __webpack_public_path__ + "media/images/clearbanc-logo-d0d11595a924cda0e7e7ad28ab1aaa51.svg";